(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .service('TimeService', TimeService);

  function TimeService() {
    var SECONDS = 1000;
    var MINUTES = 60000;
    var HOURS   = 3600000;

    //////////////////////////////////////////
    // Service object declaration
    var service = {
      milisseconds: FromMilisseconds,
      seconds: FromSeconds,
      minutes: FromMinutes,
      hours: FromHours
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function FromMilisseconds(value) {
      return Chain(value);
    }

    function FromSeconds(value) {
      return Chain(value * SECONDS);
    }

    function FromMinutes(value) {
      return Chain(value * MINUTES);
    }

    function FromHours(value) {
      return Chain(value * HOURS);
    }

    function Chain(value) {
      return {
        toMilisseconds: function() { return value; },
        toSeconds: function() { return value / SECONDS; },
        toMinutes: function() { return value / MINUTES; },
        toHours: function() { return value / HOURS; }
      };
    }
  }

}());
